<template>
	<v-container fluid>
		<v-row align="center" justify="center">
			<v-col cols="12" sm="6" md="4" order="1" class="pt-0 pl-4">
				<v-img
					src="img/ifk-research.png"
					height="65px"
					width="195px"
					class="head-logo"
					contain
				></v-img>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="12" md="4" order="3" order-md="2">
				<v-text-field
					label="Поиск"
					v-model="search"
					outlined rounded
					hide-details
					clearable
				></v-text-field>
				<!-- {{ breakpoint }} -->
			</v-col>
			<v-spacer></v-spacer>
			<v-col v-if="$vuetify.breakpoint.smAndUp" cols="6" md="4" order="2" order-md="3" class="text-right">
				<v-btn
					v-if="isAdmin"
					icon
					@click="add"
				>
					<v-icon>add</v-icon>
				</v-btn>
				<v-btn
					icon
					@click="logout"
				>
					<v-icon>exit_to_app</v-icon>
				</v-btn>
			</v-col>
		</v-row>
		<v-container>
			<v-row justify="center">
				<v-col cols="auto" class="pb-0">
					<v-chip-group
						v-model="tagSearch"
						multiple
						column
						active-class="secondary"
					>
						<v-chip
							v-for="(tag, i) in tags"
							:key="i"
							filter
							small
							outlined
						>
							{{ tag.name }}
						</v-chip>
						<v-chip
							v-if="tagSearch.length > 1"
							@click.stop="clearTagSearch"
							link
							small
							outlined
						>
							<v-icon>clear</v-icon>
						</v-chip>
					</v-chip-group>
				</v-col>
				<v-col cols="auto" class="pt-0">
					<v-switch
						v-if="tagSearch.length > (recentSelected ? 2 : 1)"
						v-model="any"
						label="Совпадение по любому тегу"
						hide-details
					></v-switch>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="12" sm="10" md="8">
					<v-subheader
						v-if="recentSelected && $vuetify.breakpoint.smAndDown"
						class="pl-0"
					>
						<v-icon>date_range</v-icon>
						Загружено за последние ... дней
					</v-subheader>
					<v-slider
						v-if="recentSelected"
						v-model="range"
						color="grey"
						track-color="secondary"
						thumb-color="secondary"
						:tick-labels="rangeLabels"
				        :max="5"
				        step="1"
				        ticks="always"
				        tick-size="4"
						:label="$vuetify.breakpoint.mdAndUp ? 'Загружено за последние' : ''"
						:prepend-icon="$vuetify.breakpoint.mdAndUp ? 'date_range' : ''"
					>
						<template v-slot:append>
							<div
								v-if="$vuetify.breakpoint.mdAndUp"
								class="pa-1 primary--text text--lighten-3 text-left"
								style="width: 50px"
							>
								дней
							</div>
						</template>
					</v-slider>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col
					v-for="r in results"
					:key="r.id"
					cols="12"
					md="4"
					lg="3"
					xl="2"
				>
					<v-card
						hover
						@click="open(r.id)"
					>
						<v-card-subtitle class="title font-weight-medium primary--text">
							<span class="title-box">
								{{ r.name }}
							</span>
						</v-card-subtitle>

						<v-card-text>
							<span class="text-box">
								{{ r.author }}, {{ r.region }}, {{ r.period }}
							</span>
							<v-row
								justify="start"
								class="mt-5"
								dense
							>
								<v-col
									cols="auto"
									v-if="r.createdUnix > newLimit"
								>
									<v-chip
										small
										text-color="white"
										color="primary"
									>
										<v-icon
											left
											small
											color="secondary"
										>
											star
										</v-icon>
										Новое
									</v-chip>
								</v-col>
								<template v-for="(tag, i) in r.tags">
									<v-col
										cols="auto"
										:key="i"
										v-if="tag.visible"
									>
										<v-chip
											small
											outlined
											text-color="primary"
											color="secondary"
										>
											{{ tag.name }}
										</v-chip>
									</v-col>
								</template>
								<v-col
									cols="auto"
									v-if="r.ellipsis"
								>
									<v-chip
										small
										outlined
										text-color="primary"
										color="secondary"
									>
										...
									</v-chip>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<v-row
				v-if="loading"
				justify="center"
			>
				<v-col cols="auto" class="mt-10">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</v-col>
			</v-row>
			<v-row
				v-else-if="results.length == 0"
				justify="center"
			>
				<v-col cols="auto" class="mt-10">
					Извините, результатов нет
				</v-col>
			</v-row>
		</v-container>
		<v-dialog
			v-model="dialog.edit.show"
			max-width="800"
			persistent
		>
			<v-form ref="f" v-model="dialog.edit.valid">
				<v-card>
					<v-card-title class="headline">
						{{ dialog.edit.title }}
					</v-card-title>

					<v-card-text>
						<v-text-field
							v-model="dialog.edit.research.name"
							:rules="[ required ]"
							label="Название"
						></v-text-field>
						<v-text-field
							v-model="dialog.edit.research.author"
							:rules="[ required ]"
							label="Автор"
						></v-text-field>
						<v-text-field
							v-model="dialog.edit.research.region"
							:rules="[ required ]"
							label="Регион"
						></v-text-field>
						<v-text-field
							v-model="dialog.edit.research.period"
							:rules="[ required ]"
							label="Период"
						></v-text-field>
						<v-switch
							v-if="!dialog.edit.new"
							v-model="dialog.edit.enableFiles"
							label="Заменить файлы"
						></v-switch>
						<v-file-input
							v-model="dialog.edit.research.files"
							label="Файлы"
							v-show="dialog.edit.enableFiles"
							:rules="[ required ]"
							:chips="true"
							multiple
						></v-file-input>
						<v-combobox
							v-model="dialog.edit.research.tags"
							label="Теги"
							:rules="[ required ]"
							chips
							deletable-chips
							multiple
							hide-selected
							:delimiters="[',', ';']"
							:items="tags"
							item-text="name"
							item-value="name"
							hint="Выберите из раскрвающегося списка или введите новый тег и нажмите Enter"
							persistent-hint
						>
							<template v-slot:prepend>
								<v-icon
									class="mt-1"
								>
									turned_in
								</v-icon>
							</template>
							<template v-slot:selection="data">
								<v-chip
									v-bind="data.attrs"
									:input-value="data.selected"
									close
									@click="data.select"
									@click:close="removeTag(data.item)"
									outlined
									text-color="primary"
									color="secondary"
								>
									{{ data.item.name }}
								</v-chip>
							</template>
						</v-combobox>
					</v-card-text>

					<v-card-actions class="px-4 pt-10 pb-5">
						<v-btn
							color="primary"
							:disabled="!dialog.edit.valid"
							@click="submit"
						>
							Готово
						</v-btn>
						<v-btn
							color="secondary"
							@click="cancel"
						>
							Отмена
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
		<v-dialog
			v-model="dialog.view.show"
			max-width="800"
		>
			<v-card>
				<v-card-title class="headline">
					{{ dialog.view.research.name }}
					<v-spacer></v-spacer>
					<v-btn
						icon
						v-if="$vuetify.breakpoint.smAndUp && dialog.view.research.name.length < 60"
						@click="dialog.view.show = false"
					>
						<v-icon>clear</v-icon>
					</v-btn>
				</v-card-title>

				<v-card-text>
					<v-list dense>
						<v-list-item class="pl-0">
							<v-list-item-content>
								Подготовлен: {{ dialog.view.research.author }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-list-item-content>
								Загружен: {{ dialog.view.research.created }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="pl-0">
							<v-list-item-content>
								За период: {{ dialog.view.research.period }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-list-item-content>
								Обновлен: {{ dialog.view.research.updated }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="pl-0 mb-5">
							<v-list-item-content>
								По региону: {{ dialog.view.research.region }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-list-item-content>
								Просмотры: {{ dialog.view.research.clicks }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item
							class="pl-0"
							v-for="f in dialog.view.research.files"
							:key="f.serverName"
						>
							<v-chip
								link
								outlined
								color="primary"
								text-color="primary"
								@click="fileOpen(f.serverName)"
							>
								<v-icon left small>attach_file</v-icon>
								<div class="d-inline-block text-truncate">
									{{ f.name }}
								</div>
							</v-chip>
						</v-list-item>
						<v-list-item class="pl-0 mt-5">
							<v-row justify="start" dense>
								<v-col
									cols="auto"
									v-for="(tag, i) in dialog.view.research.tags"
									:key="i"
								>
									<v-chip
										color="secondary"
										text-color="primary"
										outlined
										small
										link
										@click="searchTag(tag)"
									>
										{{ tag.name }}
									</v-chip>
								</v-col>
							</v-row>
						</v-list-item>
					</v-list>
				</v-card-text>

				<v-card-actions
					class="px-4 pt-10 pb-5"
					v-if="isAdmin"
				>
					<v-btn
						color="primary"
						@click="edit"
					>
						Редактировать
					</v-btn>
					<v-btn
						color="secondary"
						@click="remove(dialog.view.research.id)"
					>
						Удалить
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<script>
	import { api } from '../lib/api'
	import _ from 'lodash'
	import Vue from 'vue'
	import lineClamp from 'vue-line-clamp'

	Vue.use(lineClamp)

	export default {
		data() {
			return {
				loading: false,
				dialog: {
					edit: {
						show: false,
						title: '',
						research: {
							id: 0,
							name: '',
							author: '',
							region: '',
							period: '',
							files: [],
							tags: [],
						},
						valid: false,
						new: true,
						enableFiles: true,
					},
					view: {
						show: false,
						research: {
							id: 0,
							name: '',
							author: '',
							region: '',
							period: '',
							created: '',
							updated: '',
							clicks: '',
							files: [],
							tags: [],
						},
					},
				},
				tags: [],
				researches: [],
				search: '',
				tagSearch: [],
				any: true,
				rangeLabels: [
					'365',
					'180',
					'90',
					'30',
					'7',
					'1',
				],
				range: 0,
				newLimit: 0,
			}
		},
		methods: {
			logout() {
				this.$store.dispatch('destroyToken')
			},
			add() {
				this.dialog.edit.show = true
				this.dialog.edit.title = 'Добавить материал'
				this.dialog.edit.new = true
				this.dialog.edit.enableFiles = true
			},
			cancel() {
				this.clearEdit()
				this.dialog.edit.show = false
			},
			required(v) {
				return v.length > 0 || 'Обязательное поле'
			},
			submit() {
				this.$store.dispatch('dialogLoadingStart')

				var formData = new FormData()

				formData.append('form', JSON.stringify({
					id: this.dialog.edit.research.id,
					name: this.dialog.edit.research.name,
					author: this.dialog.edit.research.author,
					region: this.dialog.edit.research.region,
					period: this.dialog.edit.research.period,
					tags: this.dialog.edit.research.tags
				}))

				if (this.dialog.edit.enableFiles) {
					let l = this.dialog.edit.research.files.length
					for (let i = 0; i < l; i++) {
						formData.append('files[]', this.dialog.edit.research.files[i])
					}
				}

				let path = this.dialog.edit.new ? 'research/add' : 'research/edit'

				api.post(path, formData)
				.then(response => {
					this.dialog.edit.show = false
					this.clearEdit()
					// this.$store.dispatch('dialogLoadingStop')
					this.getResearches()
					this.getTags()
				}, error => {
					this.$store.dispatch('dialogLoadingStop')
				})
			},
			clearEdit() {
				this.dialog.edit.research.id = 0
				this.dialog.edit.research.name = ''
				this.dialog.edit.research.author = ''
				this.dialog.edit.research.region = ''
				this.dialog.edit.research.period = ''
				this.dialog.edit.research.files = []
				this.dialog.edit.research.tags = []
				this.$refs.f.resetValidation()
			},
			getTags() {
				api.post('research/get_tags')
				.then(response => {

					this.tags = response.data.tags
					this.tags.push({
						name: 'Последнее добавленное',
						recent: true,
					})

				}, error => {})
			},
			getResearches() {
				this.loading = true

				api.post('research/get_researches')
				.then(response => {

					this.researches = []

					this.researches = response.data.researches

					var len = 63
					if (this.$vuetify.breakpoint.smOnly) len = 80
					else if (this.$vuetify.breakpoint.xlOnly) len = 63

					this.researches.forEach(r => {
						let l = 0

						if (r.createdUnix > this.newLimit) {
							l += 8
							l += 6
						}

						r.tags.forEach(t => {
							l += t.name.length
							l += 6
							this.$set(t, 'visible', l < len)
						})

						this.$set(r, 'ellipsis', l >= len)
					})

					this.$store.dispatch('dialogLoadingStop')
					this.loading = false

				}, error => {})
			},
			open(id) {
				this.dialog.view.show = true
				this.dialog.view.research = this.researches.find(r => r.id == id)
				this.click()
			},
			clearView() {
				this.dialog.view.research = {
					id: 0,
					name: '',
					author: '',
					period: '',
					region: '',
					files: [],
					tags: [],
				}
			},
			fileOpen(serverName) {
				window.open(api.path() + 'file.php?n=' + serverName)
			},
			edit() {
				this.dialog.edit.research = _.cloneDeep(this.dialog.view.research)
				this.dialog.edit.title = 'Редактировать материал'
				this.dialog.edit.new = false
				this.dialog.edit.enableFiles = false

				this.clearView()
				this.dialog.view.show = false
				this.dialog.edit.show = true
			},
			remove(id) {
				this.$store.dispatch('dialogConfirm', {
					title: 'Подтверждение',
					message: 'Удалить материал?'
				})
				.then(confirm => {
					if (confirm) {
						api.post('research/remove', {
							id: id
						})
						.then(response => {
							this.getResearches()
							this.dialog.view.show = false
						}, error => {})
					}
				})
			},
			click() {
				api.post('research/click', {
					id: this.dialog.view.research.id
				})
				.then(response => {
					// this.dialog.view.research.clicks++
				}, error => {})
			},
			removeTag(item) {
				const index = this.dialog.edit.research.tags.indexOf(item)
				if (index >= 0) this.dialog.edit.research.tags.splice(index, 1)
			},
			searchTag(tag) {
				let tagFromTags = this.tags.find(t => t.name == tag.name)
				if (tagFromTags !== undefined) {
					this.dialog.view.show = false
					this.tagSearch.push(this.tags.indexOf(tagFromTags))
				}
			},
			clearTagSearch() {
				this.tagSearch.splice(0, this.tagSearch.length)
			},
		},
		computed: {
			isAdmin() {
				return +this.$store.getters.isAdmin
			},
			tagsSelected() {
				return this.tags.filter((t, i) => {
					if (t.recent === true) return 0
					else return this.tagSearch.indexOf(i) >= 0
				})
			},
			recentSelected() {
				return this.tags.some((t, i) => {
					if (t.recent === true
						&& this.tagSearch.indexOf(i) >= 0
					) {
						return true
					}
					else return false
				})
			},
			results() {

				var createdUnixMin = Math.round(+ new Date() / 1000)
				createdUnixMin -= this.rangeLabels[this.range] * 86400
				// console.log(createdUnixMin)

				return this.researches.filter(r => {
					var tags = true
					var search = true
					var recent = true

					if (this.tagsSelected.length > 0) {
						tags = false
						if (this.any) {
							if (this.tagsSelected.some(tag => {
								return r.tags.find(t => t.name == tag.name) !== undefined
							})) {
								tags = true
							}
						}
						else {
							if (this.tagsSelected.every(tag => {
								return r.tags.find(t => t.name == tag.name) !== undefined
							})) {
								tags = true
							}
						}
					}

					if (this.search && this.search.length > 0) {
						search = false

						var searchQuery = this.search.toLowerCase()

						if (r.name.toLowerCase().includes(searchQuery)
							|| r.period.toLowerCase().includes(searchQuery)
							|| r.region.toLowerCase().includes(searchQuery)
							|| r.author.toLowerCase().includes(searchQuery)
						) {
							search = true
						}
						else if (r.files.some(f => {
							return f.name.toLowerCase().includes(searchQuery)
						})) {
							search = true
						}
						else if (r.tags.some(t => {
							return t.name.toLowerCase().includes(searchQuery)
						})) {
							search = true
						}
					}

					if (this.recentSelected) {
						if (r.createdUnix > createdUnixMin) recent = true
						else recent = false
					}

					return tags && search && recent
				})
			},
			editTags() {
				return this.dialog.edit.research.tags
			},
			breakpoint() {
				return this.$vuetify.breakpoint.name
			},
		},
		watch: {
			editTags(val) {
				// при добавлении нового тега в диалоге редактирования,
				// он добавляется как 'name'
				// а нужно как { name: 'name' }

				this.dialog.edit.research.tags.forEach(t => {
					if (t.name === undefined) {
						let index = this.dialog.edit.research.tags.indexOf(t)
						this.dialog.edit.research.tags.splice(index, 1, { name: t })
					}
				})
			},
			recentSelected(val) {
				if (val) {
					this.range = 4
				}
			},
		},
		created() {
			this.getResearches()
			this.getTags()

			this.newLimit = Math.round(+ new Date() / 1000) - 7 * 86400
		}
	}
</script>

<style scoped>
.title-box {
    display: block;
    display: -webkit-box;
    height: 60px;
    margin: 0 auto;
    line-height: 1.4;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.text-box {
    display: block;
    display: -webkit-box;
    height: 40px;
    margin: 0 auto;
    line-height: 1.4;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
